var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlfalfa = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V8",
    stroke: "#2E8B57",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 8 15 6 15 3.5C15 1.5 12 2 12 2C12 2 9 1.5 9 3.5C9 6 12 8 12 8Z",
    fill: "#2E8B57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 12 8 10 5.5 11C3.5 11.8 4 14 4 14C4 14 6 15 9 13.5",
    fill: "#3CB371"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 12 16 10 18.5 11C20.5 11.8 20 14 20 14C20 14 18 15 15 13.5",
    fill: "#3CB371"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C12 16 9 14.5 6.5 15.5C4.5 16.3 5 18 5 18C5 18 7 19 10 17.5",
    fill: "#3CB371"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C12 16 15 14.5 17.5 15.5C19.5 16.3 19 18 19 18C19 18 17 19 14 17.5",
    fill: "#3CB371"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlfalfa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alfalfa.96479dccf8ed66cfd8b404d77782511a.svg";